import { render, staticRenderFns } from "./RiskConferenceWarningCreate.vue?vue&type=template&id=0f07a22e&scoped=true&"
import script from "./RiskConferenceWarningCreate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceWarningCreate.vue?vue&type=script&lang=js&"
import style0 from "./RiskConferenceWarningCreate.vue?vue&type=style&index=0&id=0f07a22e&prod&scoped=true&lang=css&"
import style1 from "./RiskConferenceWarningCreate.vue?vue&type=style&index=1&id=0f07a22e&prod&lang=scss&scoped=true&"
import style2 from "./RiskConferenceWarningCreate.vue?vue&type=style&index=2&id=0f07a22e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07a22e",
  null
  
)

export default component.exports